module.exports = __webpack_public_path__ + "static/media/master.2288b579.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/card-types/master.png
// module id = 566
// module chunks = 0